// Флаги контекстных подсказок (мини-спринт C, уровень 2).
// Source: docs/specs/design-revision/c-onboarding.md §2.
//
// Хранилище — localStorage, а не БД. Это персональное удобство одного
// устройства, а не состояние, которое обязано пережить переустановку или
// синхронизироваться между устройствами; заводить ради него поле и запрос
// не стоит. Худший случай при потере хранилища — человек увидит подсказку
// второй раз, и это приемлемо.
//
// Каждое обращение обёрнуто в try/catch: в приватном режиме браузера доступ
// к localStorage бросает исключение, а падать обучающая подсказка не имеет
// права — она вторична по отношению ко всему, рядом с чем стоит.

export type CoachMarkId = 'summary' | 'dynamics';

const KEY: Record<CoachMarkId, string> = {
  summary: 'healthlab:coach:summary',
  dynamics: 'healthlab:coach:dynamics',
};

/** Общий выключатель: гасит ВЕСЬ контекстный слой сразу. */
const OFF_KEY = 'healthlab:coach:off';

function read(key: string): boolean {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    // Приватный режим / заблокированные данные сайта. Считаем, что флага нет:
    // показать подсказку лишний раз безопаснее, чем не показать вовсе.
    return false;
  }
}

function write(key: string): void {
  try {
    localStorage.setItem(key, '1');
  } catch {
    // Записать не удалось — подсказка закроется в текущей сессии по состоянию
    // компонента и вернётся при следующем заходе. Ошибку не поднимаем.
  }
}

/** Показывать ли подсказку: не выключен весь слой И конкретная ещё не закрыта. */
export function shouldShowCoachMark(id: CoachMarkId): boolean {
  return !read(OFF_KEY) && !read(KEY[id]);
}

/** «Понятно» — гасит одну подсказку. */
export function dismissCoachMark(id: CoachMarkId): void {
  write(KEY[id]);
}

/**
 * «Не показывать подсказки» — гасит весь слой.
 *
 * Человек, который не хочет обучения, не должен отказываться от него дважды.
 */
export function disableAllCoachMarks(): void {
  write(OFF_KEY);
}
